<template>
  <div
    style="cursor: pointer; padding: 10px;"
    class="text-center py-5 ma-1 fill-height"
    :class="$vuetify.theme.dark == true ? 'darkModeCard' : 'whiteTheme'"
  >
    <p class="google-font mb-0" style="font-weight: 350;font-size:180%">
      <b> Registrieren</b>
    </p>
    <v-divider></v-divider><br />
    <p class="mt-3 mb-0 google-font mb-0" style="font-size:100%">
      Tritt der HolyCode Community bei.
    </p>
    <br />
    <p>
      <v-text-field
        flat
        v-model="userMail"
        solo-inverted
        hide-details
        type="email"
        prepend-inner-icon="mdi-email"
        label="E-Mail Adresse"
        single-line
      ></v-text-field>
    </p>
    <p>
      <v-text-field
        flat
        v-model="passwortRegister"
        solo-inverted
        type="password"
        hide-details
        prepend-inner-icon="mdi-lock"
        label="Passwort"
        single-line
      ></v-text-field>
    </p>
    <p>
      <v-text-field
        flat
        v-model="niceName"
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-account"
        label="Nickname"
        single-line
      ></v-text-field>
    </p>

    <p>
      <v-btn
        rounded
        block
        color="success"
        style="text-transform: capitalize;border-radius:5px;text-transform: capitalize;"
        large
        dark
        @click="register()"
        >Registrieren</v-btn
      >
    </p>
    <p v-if="error" style="background-color: red; padding: 5px; margin: 3px; border-radius: 5px;">
      {{ error?error:'' }}
    </p>
  </div>
</template>

<script>
import router from "@/router/index.js";
import sha256 from "js-sha256";
import { APIService } from "@/assets/constants/config.js";
const apiService = new APIService();
export default {
  inject: ["theme"],
  name: "RegisterCard",
  data: () => ({
    error: null,
    userMail: null,
    passwortRegister: null,
    niceName: null,
  }),
  methods: {
    formcheck() {
      
      var erg = true;
      if (this.userMail && this.passwortRegister && this.niceName) {
        
        if (!this.validateEmail(this.userMail)) {
          erg = false;
        }
        if (this.passwortRegister.length < 5) {
          erg = false;
        }
        if (this.niceName.length < 5) {
          erg = false;
        }
      } else {
        erg = false;
      }

console.log('register', erg)
      return erg;
    },
    validateEmail(mail) {
      var erg = true;
      if(!mail.includes('@')){
        erg = false;
      }
      if(!mail.includes('.')){
        erg = false;
      }
      if(mail.length < 10){
        erg = false;
      }
       if(erg){
         return true;
       }else{
         this.error = 'Bitte gib eine valide E-Mail-Adresse an.';
         setTimeout(() => {
                    this.error = null;
                }, 3000);
                return false;
       }
    },
    register() {
      if (this.formcheck()) {
        apiService
          //email pw nicename
          .register(this.userMail, sha256(this.passwortRegister), this.niceName)
          .then((response) => {
            console.log(response);
            if (response.data.erg) {
              router.push("/login");
            } else {
              this.ergMessage = response.data.msg;
            }
          });
      }
    },
  },
};
</script>
